<template>
  <div id="page" v-if="slug">
    <router-link to="/" tag="div" class="close">×</router-link>
    <article v-if="(slug === 'tos')">
      <h1>Terms of Service</h1>
      <div class="page-text">
        <p>Our advices and forecasts based on JavaScript function Math.rand(), so don't make serious decisions via this website - it would be foolish and even dangerous.</p>
        <p style="font-weight: bold;">We are not responsible for any results of usage of this service. You use advices and forecasts made by this service at your own risk.</p>
        <p style="color: #cc0000;">Please, leave this website, if you want to use it for any serious purpose.</p>
      </div>
    </article>
    <article v-else-if="(slug === 'about')">
      <h1>About the project</h1>
      <div class="page-text">
        <p><b>Fort</b> is from fortune and <b>rand</b> is from random. Random fortune. Sounds weird. Absolutely not useful site.</p>
        <p>Or useful? I've created it just for fun. If you wanna add some unexpectedness into your lifestyle - use <b>fortrand</b>.</p>
        <p>Don't forget to read our Terms of service.</p>
      </div>
    </article>
    <article v-else-if="(slug === 'copyrights')">
      <h1>Copyrights</h1>
      <div class="page-text"><p>Fortrand.com ©2015, 2019, 2020</p>
        <p>Used images:</p>
        <ul>
          <li><a href="http://www.publicdomainpictures.net/view-image.php?image=78014&amp;picture=purple-velvet-curtains-background" target="_blank">Purple Velvet Curtains Background</a> by Karen Arnold</li>
          <li><a href="https://commons.wikimedia.org/wiki/File:High_Desert_Motel,_Joshua_Tree.jpg" target="_blank">High Desert Motel, Joshua Tree</a> by Bernard Gagnon</li>
          <li><a href="https://commons.wikimedia.org/wiki/File:Cuculus_canorus_vogelartinfo_chris_romeiks_CHR0791.jpg" target="_blank">Cuculus canorus vogelartinfo chris romeiks CHR0791</a> by Vogelartinfo</li>
          <li><a href="http://subtlepatterns.com/tileable-wood/" target="_blank">tileable_wood_texture</a> by Elemis</li>
          <li><a href="https://commons.wikimedia.org/wiki/File:Swedish_Nagant_1617.jpg">Swedish Nagant 1617</a> by www.adamsguns.com</li>
          <li><a href="https://pixabay.com/photos/cards-poker-money-luck-gambling-2439149/">Incredible win in poker</a> by RJA1988</li>
          <li>Dices on the dollars by mediaphoto.org</li>
          <li><a href="https://commons.wikimedia.org/wiki/Playing_card#France:_Cards_French">Cards</a> by <a href="https://it.wikipedia.org/wiki/Utente:Trocche100">Trocche100</a></li>
          <li><a href="https://pixabay.com/photos/lottery-bingo-sweepstakes-winner-3846567/">Bingo</a> by ChiniGaray</li>
          <li><a href="https://pixabay.com/photos/colt-revolver-king-cobra-357-magnum-5102472/">Colt King Cobra</a> by Mike Gunner</li>
          <li><a href="https://pixabay.com/illustrations/on-wood-pink-stage-curtain-2106951/">Stage curtain</a> by lillaby</li>
          <li><a href="https://pixabay.com/photos/red-rock-red-rock-canyon-nevada-4159076/">Red Rock Canyon</a> by RJA1988</li>
          <li><a href="https://pixabay.com/photos/euro-coins-currency-money-yellow-1353420/">Euro coins</a> by image4you</li>
          <li>Washington quarter by <a href="https://www.usmint.gov/">U.S. Mint</a></li>
          <li><a href="https://pixabay.com/photos/currency-wealth-finances-background-3088147/">10 Rubles coins</a> by Paolinio</li>
          <li>10 Rubles by <a href="https://cbr.ru/">Central Bank of Russia</a></li>
          <li><a href="https://pixabay.com/photos/russia-moscow-red-square-church-4620664/">Moscow</a> by Vladvictoria</li>
          <li>2 NIS by <a href="https://www.boi.org.il/">Bank of Israel</a></li>
          <li><a href="https://pixabay.com/photos/drink-cold-drink-summer-tel-aviv-2446102/">Tel Aviv</a> by RJA1988</li>
          <li>2 Euro by <a href="https://www.ecb.europa.eu/">European Central Bank</a></li>
          <li><a href="https://pixabay.com/photos/munich-architecture-germany-4792435/">Munich</a> by iankelsall1</li>
        </ul>
        <p>Used audio:</p>
        <ul>
          <li><a href="https://commons.wikimedia.org/wiki/File:Common_Cuckoo_(Cuculus_canorus)_(W1CDR0001463_BD1).ogg" target="_blank">Common Cuckoo (Cuculus canorus) (W1CDR0001463 BD1)</a> by John Williams</li>
          <li><a href="http://soundbible.com/1960-Shotgun-Old-School.html" target="_blank">Shotgun Old School Sound</a> by RA The Sun God</li>
          <li><a href="http://soundbible.com/1405-Dry-Fire-Gun.html" target="_blank">Dry Fire Gun Sound</a> by Mike Koenig</li>
          <li>Fortune teller's sentences generated by Amazon Polly</li>
        </ul></div>
    </article>
    <article v-else>
      <h1>Page not found</h1>
    </article>
  </div>
</template>

<script>
  
export default {
  data: function () {
    return {
      'slug': null
    }
  },
  beforeRouteUpdate: function(to, from, next) {
    this.$data.slug = to.params.slug;
    next();
  },
  mounted: function() {
    this.$data.slug = this.$route.params.slug;
  },
  methods: {
  }
}
</script>

<style src="./../assets/css/page.css" scoped>
</style>
